import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAdvancePayments(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/prepayments/", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchSelfAdvancePayments(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("/prepayments/self", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchAdvancePayment(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/prepayments/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    editAdvancePayment(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/prepayments", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteAdvancePayment(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/prepayments", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    approveAdvancePayment(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/prepayments/approve", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateAdvancePaymentDocument(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("/prepayments/documents", data)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteAdvancePaymentDocument(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete("/prepayments/documents", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  }
};
